/**
 * Helper for cropping a string. Word boundaries will be respected
 *
 * @param {string} value Value to crop
 * @param {number} length Maximum length allowed after which cropping will be applied
 * @returns {string} Cropped value, if the value was too long
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default function (value: any, length: number): string {
  if (value.length < length) {
    return value;
  }

  const words = value.split(' ');
  let result = '';

  for (const word of words) {
    result += word + ' ';

    if (result.length > length) {
      break;
    }
  }

  return result.trim() + '...';
}
